import { useEffect } from "react"
import { useBaseMap } from "../BaseMap"
import { useHub } from "../../../core/Global"

/**
 * How the roads are flowing right now, green to red, over the map. The tiles come through the
 * hub, so HERE's key never reaches the browser. Only from city zoom in: further out every road
 * of a region would be painted.
 */
export default function TrafficLayer() {

    const { L, map } = useBaseMap()
    const hub = useHub()

    useEffect(() => {
        const TrafficTiles = L.GridLayer.extend({
            createTile: function (coords: { x: number, y: number, z: number }, done: (err: any, tile: HTMLElement) => void) {
                const tile = document.createElement("img")
                tile.alt = ""
                hub.GetBlobAsync(`/maps/routes/traffictile/${coords.z}/${coords.x}/${coords.y}`)
                    .then(blob => {
                        const url = URL.createObjectURL(blob)
                        tile.onload = () => { URL.revokeObjectURL(url); done(null, tile) }
                        tile.onerror = () => { URL.revokeObjectURL(url); done(null, tile) }
                        tile.src = url
                    })
                    // No traffic for this tile (or the hub said no): an empty tile, not an error.
                    .catch(() => done(null, tile))
                return tile
            }
        })

        const layer = new TrafficTiles({ minZoom: 8, maxZoom: 20, zIndex: 5, opacity: .9 }).addTo(map)
        return () => { layer.remove() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map])

    return null
}
